import { render } from "./id_verification.html?vue&type=template&id=472016bc&external"
import script from "./id_verification.js?vue&type=script&lang=js&external"
export * from "./id_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__